<div class="table-main-container" *ngIf="graph && exhaustGraph">
  <div class="average-container">
    <div>{{ 'graph.exhaust.table.average.title' | translate }}</div>
    <ng-container *ngIf="!exhaustGraph.averageChannel; else averageChannel">
      <div
        class="select-button"
        data-cy="graphs-exh-gas-temp-ave-select-channel-button"
        (click)="openChannelSelector()">
        {{ 'graph.exhaust.table.average.button.select' | translate }}
      </div>
    </ng-container>
  </div>

  <div class="tabs">
    <div
      class="tab"
      data-cy="graphs-exh-gas-cylinder-tab"
      (click)="tabSelected(CYLINDER_TAB)"
      [class.selected]="isCylinderTabSelected">
      {{ 'graph.exhaust.table.cylinder.title' | translate }}
    </div>
    <div
      class="tab"
      data-cy="graphs-exh-gas-turbocharger-tab"
      (click)="tabSelected(TURBO_TAB)"
      [class.selected]="isTurboTabSelected">
      {{ 'graph.exhaust.table.turbo.title' | translate }}
    </div>
  </div>

  <div class="graphs-table-main-container">
    <div class="cylinder-graph-container" *ngIf="isCylinderTabSelected">
      <div class="header-container">
        <div class="header-title">
          <div class="slots-text">
            {{
              'graph.exhaust.table.cylinder.slots'
                | translate
                  : {
                      slots: exhaustGraph.CylinderChannels.length,
                      max: maxCylinderSlots,
                    }
            }}
          </div>
          <div
            class="add-row-button"
            data-cy="graphs-exh-gas-add-cylinder-button"
            [class.disable]="!showAddCylinder()"
            (click)="addCylinderRow()">
            {{ 'graph.cylinder.table.button.add-row' | translate }}
          </div>
        </div>
      </div>
      <div class="table-container">
        <app-cylinder-graph-table-header style="width: 100%"></app-cylinder-graph-table-header>
        <div class="table-content">
          <div class="no-channel-text" *ngIf="exhaustGraph.CylinderChannels.length === 0">
            {{ 'graph.no-channels.text.cylinder' | translate }}
          </div>
          <app-cylinder-graph-table-row
            *ngFor="let channel of exhaustGraph.CylinderChannels; let i = index"
            [rowIndex]="i"
            [channel]="channel"
            [vesselId]="graph.vesselId"
            [optionsVisible]="selectedRowIndex === i"
            (onOptionsToggled)="optionsToggled(i)"
            (onDeleteRow)="deleteCylinderRow(i)"></app-cylinder-graph-table-row>
        </div>
      </div>
    </div>

    <div class="turbocharger-graph-container" *ngIf="isTurboTabSelected">
      <div class="header-container">
        <div class="header-wrapper">
          <div class="header-title">
            <div class="slots-text">
              {{
                'graph.exhaust.table.turbo.slots'
                  | translate
                    : {
                        slots: exhaustGraph.TurboChannels.length,
                        max: maxTurboSlots,
                      }
              }}
            </div>
            <div
              class="add-row-button"
              data-cy="graphs-exh-gas-add-turbocharger-button"
              (click)="addTurboRow()"
              [class.disable]="!showAddTurbo()">
              {{ 'graph.turbo.table.button.add-row' | translate }}
            </div>
          </div>
        </div>
      </div>
      <div class="table-container">
        <app-turbo-graph-table-header style="width: 100%"></app-turbo-graph-table-header>
        <div class="table-content">
          <div class="no-channel-text" *ngIf="exhaustGraph.TurboChannels.length === 0">
            {{ 'graph.no-channels.text.turbocharger' | translate }}
          </div>
          <app-turbo-graph-table-row
            *ngFor="let channel of exhaustGraph.TurboChannels; let i = index"
            style="width: 100%"
            [rowIndex]="i"
            [channel]="channel"
            [vesselId]="graph.vesselId"
            [optionsVisible]="selectedRowIndex === i"
            (onOptionsToggled)="optionsToggled(i)"
            (onDeleteRow)="deleteTurboRow(i)"
            (onChannelUpdated)="onTurboChannelUpdated()"></app-turbo-graph-table-row>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addTurboTableRow>
  <div class="add-row-container" *ngIf="exhaustGraph">
    <div style="cursor: pointer; width: fit-content; user-select: none" (click)="addTurboTable()">
      {{ 'graph.exhaust.table.turbo.add-table' | translate }}
    </div>
  </div>
</ng-template>

<ng-template #averageChannel>
  <div class="average-channel">
    <div data-cy="graphs-exh-gas-temp-ave-channel-number">
      {{ exhaustGraph.averageChannel.fcuData.fcuChannelId }}
    </div>
    <div data-cy="graphs-exh-gas-temp-ave-channel-name">
      {{ exhaustGraph.averageChannel.opsData.name }}
    </div>
    <div
      class="select-button"
      data-cy="graphs-exh-gas-temp-ave-change-button"
      (click)="openChannelSelector('temp')">
      {{ 'graph.exhaust.table.channel.button.change' | translate }}
    </div>
  </div>
</ng-template>

<app-confirmation-window
  #cancelConfirmation
  [mainLabel]="'graph.cancel.dialog.title'"
  [discardLabel]="'graph.cancel.dialog.discard'"
  [goBackLabel]="'graph.cancel.dialog.go-back'"
  [saveLabel]="'graph.cancel.dialog.save'"></app-confirmation-window>
